'use client';
import styles from './search-layout.module.scss';
import { type MouseEventHandler, type ReactNode } from 'react';
import Button from 'components/controls/buttons/button';
import CloseIcon from 'assets/icons/close-x.svg';
import FiltersIcon from 'assets/icons/filters.svg';

const CollectionSearchLayout = ({
	results,
	controls,
	hideControls,
	handleCloseButton,
	handleOpenButton,
}: IProps) => {
	const componentClassString = hideControls
		? `${styles.wrapper} ${styles.hideControls}`
		: `${styles.wrapper} ${styles.openControls}`;

	return (
		<div>
			<section
				className={componentClassString}
				data-lock-page-mobile-only={!hideControls}
			>
				<div className={styles.controls}>
					{!hideControls && (
						<button className={styles.closeButton} onClick={handleCloseButton}>
							Close <CloseIcon />
						</button>
					)}
					{controls}
				</div>
				<div className={styles.results}>{results}</div>
			</section>
			{hideControls && (
				<div className={styles.buttonWrapper}>
					<Button
						className={styles.filtersButton}
						appearance="secondary"
						onClick={handleOpenButton}
					>
						Filter <FiltersIcon />
					</Button>
				</div>
			)}
		</div>
	);
};

export interface IProps {
	controls?: ReactNode;
	handleCloseButton: MouseEventHandler;
	handleOpenButton: MouseEventHandler;
	hideControls?: boolean;
	results?: ReactNode;
}

export default CollectionSearchLayout;
